// noinspection DuplicatedCode

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinKlien = createAsyncThunk(
  "klien/getMin",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMinMasterKlien",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        let newObj = [];
        response.data.data.map((item) =>
          newObj.push({
            value: item.KlienID,
            label: item.NamaKlien,
          })
        );
        return { data: newObj };
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getKlien = createAsyncThunk(
  "klien/get",
  async ({ start, count, search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMasterKlien",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertKlien = createAsyncThunk(
  "klien/insert",
  async (
    {
      DetailAccountID,
      Jabatan,
      NamaKlien,
      Kontak,
      Alamat,
      NPWP,
      AlamatNPWP,
      Catatan,
      NoTlpn,
      CQ,
    },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("DetailAccountID", DetailAccountID);
    formData.append("Jabatan", Jabatan);
    formData.append("NamaKlien", NamaKlien);
    formData.append("Kontak", Kontak);
    formData.append("Alamat", Alamat);
    formData.append("NPWP", NPWP);
    formData.append("AlamatNPWP", AlamatNPWP);
    formData.append("Catatan", Catatan);
    formData.append("NoTlpn", NoTlpn);
    formData.append("CQ", JSON.stringify(CQ || []));
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertMasterKlien",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(
        e.response?.data || { message: e.message }
      );
    }
  }
);

export const updateKlien = createAsyncThunk(
  "klien/update",
  async (
    {
      DetailAccountID,
      Jabatan,
      NamaKlien,
      Kontak,
      Alamat,
      NPWP,
      AlamatNPWP,
      Catatan,
      NoTlpn,
      CQ,
      KlienID,
      status,
    },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("DetailAccountID", DetailAccountID);
    formData.append("Jabatan", Jabatan);
    formData.append("NamaKlien", NamaKlien);
    formData.append("Kontak", Kontak);
    formData.append("Alamat", Alamat);
    formData.append("NPWP", NPWP);
    formData.append("AlamatNPWP", AlamatNPWP);
    formData.append("Catatan", Catatan);
    formData.append("NoTlpn", NoTlpn);
    formData.append("CQ", JSON.stringify(CQ || []));
    formData.append("KlienID", KlienID);
    formData.append("status", status);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateMasterKlien",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(
        e.response?.data || { message: e.message }
      );
    }
  }
);

export const insertUserClient = createAsyncThunk(
  "klien/update",
  async ({ Nik, Username }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("Username", Username);

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertUserClient",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

const initialState = {
  message: "",
  minData: [],
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
};

export const klienSlice = createSlice({
  name: "klien",
  initialState,
  reducers: {},
  extraReducers: {
    [getMinKlien.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minData = payload.data;
      return state;
    },
    [getMinKlien.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload.message;
    },
    [getMinKlien.pending]: (state) => {
      state.isMinFetching = true;
    },

    [getKlien.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getKlien.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload.message;
    },
    [getKlien.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertKlien.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [insertKlien.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload?.message;
    },
    [insertKlien.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updateKlien.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [updateKlien.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload?.message;
    },
    [updateKlien.pending]: (state) => {
      state.isUpdateFetching = true;
    },

    // UserClient
    [insertUserClient.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [insertUserClient.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [insertUserClient.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const klienSelector = (state) => state.klien;
